// extracted by mini-css-extract-plugin
export default {"container":"styles_container__Pstr1","title":"styles_title__Cw0pN","body":"styles_body__zemKT","section":"styles_section__3TwqM"};